import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { fmtMoney } from "@/lib/finance";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";

export const LedgerTable = ({ entries }) => {
  const exportCsv = () => {
    const header = "Date,Opening Principal,Daily Rate,Yield,Closing Balance\n";
    const rows = entries.map((e) =>
      `${e.ledger_date_iso},${e.opening_principal.toFixed(2)},${(e.daily_yield_rate * 100).toFixed(2)}%,${e.yield_amount.toFixed(2)},${e.closing_balance.toFixed(2)}`
    ).join("\n");
    const blob = new Blob([header + rows], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "aureon_daily_ledger.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="glass rounded-xl border border-[#232D40] overflow-hidden" data-testid="ledger-table">
      <div className="px-5 py-4 border-b border-[#232D40] flex items-center justify-between">
        <div>
          <h2 className="font-heading text-lg font-semibold">Daily Yield Ledger</h2>
          <p className="text-xs text-slate-500">Snapshot of each 24h compounding cycle</p>
        </div>
        <Button data-testid="export-ledger-btn" size="sm" variant="outline" onClick={exportCsv}
          className="border-[#232D40] bg-white/5 text-xs h-8">
          <Download className="h-3.5 w-3.5 mr-1.5" />CSV
        </Button>
      </div>
      <div className="max-h-[360px] overflow-y-auto">
        <Table>
          <TableHeader className="sticky top-0 bg-[#121722] z-10">
            <TableRow className="border-[#232D40] hover:bg-transparent">
              <TableHead className="text-slate-400 text-xs">Date</TableHead>
              <TableHead className="text-slate-400 text-xs text-right">Opening</TableHead>
              <TableHead className="text-slate-400 text-xs text-right">Yield +5%</TableHead>
              <TableHead className="text-slate-400 text-xs text-right">Closing</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {entries.length === 0 && (
              <TableRow><TableCell colSpan={4} className="text-center text-slate-500 py-8 text-sm">No ledger entries yet.</TableCell></TableRow>
            )}
            {entries.slice(0, 120).map((e, i) => (
              <TableRow key={i} className="border-[#232D40] hover:bg-white/[0.02] font-mono-data text-sm">
                <TableCell className="text-slate-300">{e.ledger_date_iso}</TableCell>
                <TableCell className="text-right text-slate-400">{fmtMoney(e.opening_principal, 0)}</TableCell>
                <TableCell className="text-right text-emerald-400">+{fmtMoney(e.yield_amount, 0)}</TableCell>
                <TableCell className="text-right text-slate-100 font-semibold">{fmtMoney(e.closing_balance, 0)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
